import { Helmet } from 'react-helmet-async';

import { Calendar } from '../components/calendar/Calendar';
import { t } from '../services/translation/translation';

export const TripsCalendarRoute = () => {
  return (
    <div>
      <Helmet>
        <title>{t('side-bar.trips-calendar')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('side-bar.trips-calendar')}</h3>
      <Calendar />
    </div>
  );
};
